import script from "./ModalApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalApp.vue?vue&type=script&setup=true&lang=js"

import "./ModalApp.vue?vue&type=style&index=0&id=4bf57f70&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf57f70"]])

export default __exports__